const cheapCarRental = {
    TL_LOCATION_LIST_CLASS: '.tl-container-wrapper',
    TL_SECTION_CLASS: '.cheap-car-rental',
    PICK_UP_DATE_ID: '#pick-date',
    DROP_OFF_DATE_ID: '#drop-date',
    SEARCH_URL: _d.url.search.createSearch,
    CHEAP_SEARCH_URL: '/cheap-car-rental/search',
    SEARCH_BUTTON_ID: '#location-submit',
    init: () => {
        const searchButton = $(cheapCarRental.SEARCH_BUTTON_ID);

        if (!$(cheapCarRental.TL_SECTION_CLASS).length) {
            return;
        }

        //Hack to remove all event-listeners connected to button by id and make default click
        searchButton.attr('id', 'cheapCarRentalSearch');

        cheapCarRental.searchRequest(searchButton);
        cheapCarRental.openDropdownTrack();
        cheapCarRental.trackLinkClickAndSubmit();

        $('#disclaimer-button').on('click', function() {
            const disclaimerBlock = $('#disclaimer');

            disclaimerBlock.text(disclaimerBlock.data('disclaimer'));
        });
    },

    /**
     * @param {string} response
     *
     * @return {void}
     */
    replaceResults(response) {
        const container = $(cheapCarRental.TL_LOCATION_LIST_CLASS);

        container.fadeTo(100, 0);
        setTimeout(() => {
            container.html(response).fadeTo(200, 1);
            cheapCarRental.openDropdownTrack();
            cheapCarRental.trackLinkClickAndSubmit();

            $('.tl-open').on('click', function(e) {
                e.preventDefault();
                $(this).toggleClass('opened').next().slideToggle();
            });
        }, 100);
    },
    trackLinkClickAndSubmit() {
        $('[data-locid]').on('click', (e) => {
            e.preventDefault();
            const link = $(e.target);
            const locationId = link.data('locid');
            const cityId = link.data('cityid');
            const countryId = link.data('countid');


            const dateFrom = $('#pick-date').val() + ' ' +
                    $('#pick-time').val(),
                timeFrom = $('#pick-time').val(),
                dateTill = $('#drop-date').val() + ' ' + $('#drop-time').val(),
                timeTill = $('#drop-time').val(),
                placePick = locationId,
                placeDrop = locationId;
            let driverAge = $('#driver-age-input').val();

            if (driverAge === '30-65' || driverAge === '65-30') {
                driverAge = '35';
            } else if (driverAge === '80+') {
                driverAge = '80';
            }

            const post = {
                    is_drop_off: ($('#is-drop-off').is(':checked') ? 0 : 1),
                    pick_up_country_id: countryId,
                    pick_up_city_id: cityId,
                    pick_up_location_id: placePick,
                    drop_off_country_id: countryId,
                    drop_off_city_id: cityId,
                    partner_id: $('#partnerId').val(),
                    exclude_locations: $('#excludeLocations').val(),
                    drop_off_location_id: placeDrop,
                    pickup_id: placePick,
                    dropoff_id: placeDrop,
                    pickup_from: dateFrom,
                    pickup_to: dateTill,
                    pick_time: timeFrom,
                    drop_time: timeTill,
                    luxOnly: 0,
                    driver_age: driverAge,
                    residence_country: $('#residence-input').val() || $('#sb-residence').val()
                };

            $('#cheapCarRentalSearch').addClass('loading');

            /*
             * As per browser will block the new tab because it is not a direct user action
             * https://attacomsian.com/blog/javascript-open-url-in-new-tab#asynchronous-http-request
             */
            const tab = window.open('about:blank');

            fetch(cheapCarRental.SEARCH_URL, {
                method: 'POST',
                mode: 'same-origin',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(post)
            })
            .then(response => response.json())
            .then(response => {
                if (response.success) {
                    tab.location = response.data.url;
                    tab.focus();
                    setTimeout(() => $('#cheapCarRentalSearch').removeClass('loading'), 300);
                } else {
                    tab.close();
                }
            }).catch(() => {
                // close the empty window
                tab.close();
            });
        });
    },
    /**
     *
     * @return {void}
     * @param {Element} searchButton
     */
    searchRequest(searchButton) {
        searchButton.on('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            searchButton.addClass('loading');

            const pickDate = $(cheapCarRental.PICK_UP_DATE_ID).val();
            const dropOffDate = $(cheapCarRental.DROP_OFF_DATE_ID).val();
            const { currency, language } = _d.s;

            fetch(cheapCarRental.CHEAP_SEARCH_URL, {
                method: 'POST',
                mode: 'same-origin',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ pickDate, dropOffDate, currency, language })
            }).then((response) => response.json()).then(({ response }) => {
                searchButton.removeClass('loading');
                cheapCarRental.replaceResults(response);
            }).catch((error) => {
                searchButton.removeClass('loading');
                // eslint-disable-next-line no-console
                console.error('Error:', error);
            });
        });
    },
    openDropdownTrack() {
        $('.tl-box').on('click', function() {
            const arrowElement = $(this).find('.tl-opens');
            arrowElement.toggleClass('opened');
            const dataIndex = arrowElement.data('open-index');
            $(`[data-elem-index=${ dataIndex }]`).toggle('fast');
        });
    }
};

cheapCarRental.init();
